import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupportingListsDashboardComponent } from './pages';
import { InternalSharedModule } from '../shared';

@NgModule({
  declarations: [
    SupportingListsDashboardComponent,
  ],
  imports: [
    CommonModule,
    InternalSharedModule,
  ],
  exports: [],
})
export class SupportingListsModule { }
